/**
 * Web-marketing i18n setup.
 *
 * The shared `i18n` package (packages/i18n/src/web.ts) ships its locale JSONs
 * statically-imported (FR/EN/ES/PT × common/marketing/legal), so we do NOT need
 * an HTTP backend or a public/locales/ copy. We just detect the browser language
 * up-front, then call `createWebI18n({ lng })` and re-export the instance.
 */
// Import from the web entry point specifically — the root barrel re-exports
// mobile-only modules (expo-localization, async-storage) that won't bundle
// cleanly in a Vite build.
import {
  createWebI18n,
  WEB_SUPPORTED_LANGUAGES,
  WEB_DEFAULT_LANGUAGE,
  type WebLanguage,
} from 'i18n/web';

function detectInitialLanguage(): WebLanguage {
  if (typeof navigator === 'undefined') return WEB_DEFAULT_LANGUAGE;
  const candidates = [
    ...(navigator.languages ?? []),
    navigator.language,
  ].filter(Boolean);
  for (const raw of candidates) {
    const code = raw.toLowerCase().slice(0, 2);
    if ((WEB_SUPPORTED_LANGUAGES as readonly string[]).includes(code)) {
      return code as WebLanguage;
    }
  }
  return WEB_DEFAULT_LANGUAGE;
}

export const i18n = createWebI18n({
  lng: detectInitialLanguage(),
  defaultNS: 'marketing',
});

export default i18n;
